import { useMutation } from "react-query";
import { createNewPassword, forgotPassword, verifyOTP } from "../apis/auth";

const useForgotPassword = ({ onSuccess, onError }) => {
	const mutation = useMutation({
		mutationFn: (email) => forgotPassword(email),
		onSuccess: (data) => {
			if (onSuccess) {
				onSuccess(data);
			}
		},
		onError: (error) => {
			if (onError) {
				onError(error);
			}
		},
	});

	return {
		reset: mutation.mutate,
		isLoading: mutation.isLoading,
		isError: mutation.isError,
		isSuccess: mutation.isSuccess,
	};
};

const useCreateNewPassword = ({ onSuccess, onError }) => {
	const mutation = useMutation({
		mutationFn: (payload) => createNewPassword(payload),
		onSuccess: (data) => {
			if (onSuccess) {
				onSuccess(data);
			}
		},
		onError: (error) => {
			if (onError) {
				onError(error);
			}
		},
	});

	return {
		newPassword: mutation.mutate,
		isLoading: mutation.isLoading,
		isError: mutation.isError,
		isSuccess: mutation.isSuccess,
	};
};

const useVerifyOtp = ({ onSuccess, onError }) => {
	const mutation = useMutation({
		mutationFn: (payload) => verifyOTP(payload),
		onSuccess: (data) => {
			if (onSuccess) {
				onSuccess(data)
			}
		},
		onError: (error) => {
			if (onError) {
				onError(error)
			}
		},
	});

	return {
		verify: mutation.mutate,
		isLoading: mutation.isLoading,
		isError: mutation.isError,
		isSuccess: mutation.isSuccess,
	};
};

export { useForgotPassword, useCreateNewPassword, useVerifyOtp };
